import {
  Box,
  Button,
  FormControl,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { ActiveStatus, HealthCheck } from '../../schema/ptt';

interface HealthApplicationProps {
  person_id?: string | number;
  editable?: boolean;
  reloadStatus?: () => void;
}

const HealthApplicationPage: React.FC<HealthApplicationProps> = ({
  person_id,
  editable,
  reloadStatus
}: HealthApplicationProps) => {
  const [healthCheck, setHealthCheck] = useState<HealthCheck | null>(null);
  const [activeStatus, setActiveStatus] = useState<ActiveStatus | null>(null);
  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };

  const saveTempStatus = () => {
    if (isLoading) {
      return;
    }
    if (!editable) {
      return;
    }
    if (activeStatus) {
      setIsLoading(true);
      api
        .post(`person/${person_id}/temporary_status`, {
          is_health_check_active: activeStatus.is_temp_active,
          health_check_comment: activeStatus.comment
        })
        .then(() => {
          openSuccessDialog();
          reloadStatus && reloadStatus();
        })
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => {
    if (person_id) {
      api.get(`/person/${person_id}/health_check`).then((res) => {
        const { data } = res;
        setHealthCheck(data);
      });
      api.get(`/person/${person_id}/health_check/status`).then((res) => {
        const { data } = res;
        setActiveStatus(data);
      });
    }
  }, [person_id]);

  let bp = null;
  let alcohol = null;
  let drug = null;
  // let SYSTOLIC = null;
  // let DIASTOLIC = null;
  // let PULSE = null;
  // let TEMP = null;
  // let ALCOHOL = null;
  // let DRUG = null;
  if (healthCheck) {
    bp = healthCheck.Measurements.find((data) => data.Name == 'BP');
    alcohol = healthCheck.Measurements.find((data) => data.Name == 'Alcohol');
    drug = healthCheck.Measurements.find((data) => data.Name == 'Drug');
    // SYSTOLIC = healthCheck.Measurements.find((data) => data.Name == 'SYSTOLIC');
    // DIASTOLIC = healthCheck.Measurements.find((data) => data.Name == 'DIASTOLIC');
    // PULSE = healthCheck.Measurements.find((data) => data.Name == 'PULSE');
    // TEMP = healthCheck.Measurements.find((data) => data.Name == 'TEMP');
    // ALCOHOL = healthCheck.Measurements.find((data) => data.Name == 'ALCOHOL');
    // DRUG = healthCheck.Measurements.find((data) => data.Name == 'DRUG');
  }
  return (
    // <Typography variant="h6" mt={3}>
    //   ไม่พบข้อมูล การสุ่มตรวจร่างกาย
    // </Typography>
    <>
      {healthCheck == null ? (
        <Typography variant="h6" mt={3}>
          ไม่พบข้อมูล การสุ่มตรวจร่างกาย
        </Typography>
      ) : (
        <>
          <Typography variant="h6">การอนุญาต การสุ่มตรวจร่างกาย</Typography>
          {activeStatus?.is_active ? (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="สถานะการอนุญาต"
                    variant="outlined"
                    placeholder="สถานะการอนุญาต"
                    value={'ผ่านโดยระบบ'}
                    autoComplete="off"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  {editable ? (
                    <FormControl fullWidth>
                      <InputLabel id="is_active">สถานะการอนุญาตชั่วคราว</InputLabel>
                      <Select
                        labelId="is_active"
                        label="สถานะการอนุญาตชั่วคราว"
                        variant="outlined"
                        onChange={(e) =>
                          activeStatus
                            ? setActiveStatus({
                                ...activeStatus,
                                is_temp_active: e.target.value == 'true'
                              })
                            : null
                        }
                        value={`${activeStatus?.is_temp_active === true}`}
                        autoComplete="off"
                        disabled={!activeStatus}
                      >
                        <MenuItem value={'true'}>ผ่าน</MenuItem>
                        <MenuItem value={'false'}>ไม่ผ่าน</MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      fullWidth
                      label="สถานะการอนุญาต"
                      variant="outlined"
                      placeholder="สถานะการอนุญาต"
                      value={activeStatus?.is_temp_active ? 'ผ่าน' : 'ไม่ผ่าน'}
                      autoComplete="off"
                      InputProps={{
                        readOnly: true
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    label="หมายเหตุการอนุญาตชั่วคราวโดยเจ้าหน้าที่"
                    variant="outlined"
                    placeholder="หมายเหตุการอนุญาตชั่วคราวโดยเจ้าหน้าที่"
                    onChange={(e) =>
                      activeStatus
                        ? setActiveStatus({ ...activeStatus, comment: e.target.value })
                        : null
                    }
                    value={activeStatus?.comment ? activeStatus.comment : ''}
                    autoComplete="off"
                    disabled={!activeStatus}
                  />
                </Grid>
              </Grid>
              {editable ? (
                <Grid container columns={2} spacing={2} sx={{ mt: 0 }} direction={'row-reverse'}>
                  <Grid item>
                    <Button onClick={() => saveTempStatus()} variant="contained" color="primary">
                      บันทึก
                    </Button>
                  </Grid>
                </Grid>
              ) : null}
            </Box>
          )}
          <Typography variant="h6" sx={{ mt: 2 }}>
            การสุ่มตรวจร่างกาย
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="ผลทดสอบ Fit To Work"
                  variant="outlined"
                  placeholder="ผลทดสอบ Fit To Work"
                  value={healthCheck?.EvaluationResult == 'N' ? 'ผ่าน' : 'ไม่ผ่าน'}
                  InputProps={{ readOnly: true }}
                  disabled={!healthCheck?.EvaluationResult}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="วันสิ้นสุดผลทดสอบ"
                  variant="outlined"
                  placeholder="วันสิ้นสุดผลทดสอบ"
                  value={
                    healthCheck?.Expried ? dayjs(healthCheck.Expried).format('DD/MM/YYYY') : ''
                  }
                  InputProps={{ readOnly: true }}
                  disabled={!healthCheck?.Expried}
                />
              </Grid>
              {bp ? (
                <>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="ความดันโลหิตตัวบน (SYS)"
                      variant="outlined"
                      placeholder="mm/Hg"
                      value={`${
                        bp.Value
                          ? bp.Value.split('/').length > 0
                            ? bp.Value?.split('/')[0]
                            : '-'
                          : '-'
                      } ${bp.Unit} | ${
                        bp.RegulartionType == 'N'
                          ? 'ปกติ'
                          : bp.RegulartionType == 'W'
                          ? 'อยู่ในเกณฑ์เฝ้าระวัง'
                          : bp.RegulartionType == 'F'
                          ? 'ความดันสูง'
                          : 'ไม่มีข้อมูล'
                      }`} // N = ปกติ (สีเขียว) W = อยู่ในเกณฑ์เฝ้าระวัง (สีเหลือง)  F = ความดันสูง (สีแดง)
                      InputProps={{ readOnly: true }}
                      disabled={!bp}
                      sx={{
                        input: {
                          color:
                            bp.RegulartionType == 'N'
                              ? 'green'
                              : bp.RegulartionType == 'W'
                              ? 'yellow'
                              : bp.RegulartionType == 'F'
                              ? 'red'
                              : 'gray'
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="ความดันโลหิตตัวล่าง (DIA)"
                      variant="outlined"
                      placeholder="mm/Hg"
                      value={`${
                        bp.Value
                          ? bp.Value.split('/').length > 1
                            ? bp.Value?.split('/')[1]
                            : '-'
                          : '-'
                      } ${bp.Unit} | ${
                        bp.RegulartionType == 'N'
                          ? 'ปกติ'
                          : bp.RegulartionType == 'W'
                          ? 'อยู่ในเกณฑ์เฝ้าระวัง'
                          : bp.RegulartionType == 'F'
                          ? 'ความดันสูง'
                          : 'ไม่มีข้อมูล'
                      }`} // N = ปกติ (สีเขียว) W = อยู่ในเกณฑ์เฝ้าระวัง (สีเหลือง)  F = ความดันสูง (สีแดง)
                      InputProps={{ readOnly: true }}
                      disabled={!bp}
                      sx={{
                        input: {
                          color:
                            bp.RegulartionType == 'N'
                              ? 'green'
                              : bp.RegulartionType == 'W'
                              ? 'yellow'
                              : bp.RegulartionType == 'F'
                              ? 'red'
                              : 'gray'
                        }
                      }}
                    />
                  </Grid>
                </>
              ) : null}

              {alcohol ? (
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="ระดับแอลกอฮอล์ในเลือด"
                    variant="outlined"
                    placeholder="ระดับแอลกอฮอล์ในเลือด"
                    value={alcohol.RegulartionType == 'N' ? 'ปกติ' : 'ไม่ผ่าน'}
                    InputProps={{ readOnly: true }}
                    disabled={!alcohol}
                    sx={{ input: { color: alcohol.RegulartionType == 'N' ? 'green' : 'red' } }}
                  />
                </Grid>
              ) : null}

              {drug ? (
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="สารเสพติดในเลือด"
                    variant="outlined"
                    placeholder="สารเสพติดในเลือด"
                    value={drug.RegulartionType == 'N' ? 'ปกติ' : 'ไม่ผ่าน'}
                    InputProps={{ readOnly: true }}
                    disabled={!drug}
                    sx={{ input: { color: drug.RegulartionType == 'N' ? 'green' : 'red' } }}
                  />
                </Grid>
              ) : null}
            </Grid>
          </Box>
        </>
      )}
      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลการตรวจสอบและอัปเดตบุคคลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HealthApplicationPage;
